import { createStore, applyMiddleware, combineReducers } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage
import thunk from 'redux-thunk'
import user from './user'
import graphic from './graphic'

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['user'], // elements that will be persisted
    blacklist: ['graphic'], // elements that will not be persisted
}

const rootReducer = combineReducers({
    user,
    graphic,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = createStore(persistedReducer, applyMiddleware(thunk))
const persistor = persistStore(store)

export { store, persistor }
